module.exports = __webpack_public_path__ + "static/media/BoxImage.4abe84e6.png";